import { Component, computed, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DashboardSideNavComponent } from '../dashboard-side-nav/dashboard-side-nav.component';
import { DashboardMobileNavComponent } from '../dashboard-mobile-nav/dashboard-mobile-nav.component';
import { DashboardTopNavComponent } from '../dashboard-top-nav/dashboard-top-nav.component';

@Component({
  selector: 'qwiko-dashboard-shell',
  imports: [
    RouterModule,
    DashboardSideNavComponent,
    DashboardMobileNavComponent,
    DashboardTopNavComponent,
  ],
  templateUrl: './dashboard-shell.component.html',
  styleUrl: './dashboard-shell.component.scss',
})
export class DashboardShellComponent {
  sideNavIsOpen = signal<boolean>(true);
}
